module.exports = __webpack_public_path__ + "static/media/easypay.8b2fb4fa.png";